/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiAllNodeVisitor } from '../../visitors/AaiAllNodeVisitor';

/**
 * Constructor.
 * @class
 * @extends AaiAllNodeVisitor
 * @author eric.wittmann@gmail.com
 */
export class Aai20AllNodeVisitor extends AaiAllNodeVisitor implements IAai20Visitor {
    public constructor() {
        super();
    }
}
Aai20AllNodeVisitor["__class"] = "io.apicurio.datamodels.asyncapi.v2.visitors.Aai20AllNodeVisitor";
Aai20AllNodeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor"];





import { IAai20Visitor } from './IAai20Visitor';

